import { action, observable, runInAction } from 'mobx';
import { StringStore } from 'ui/base/input';
import { IAccountsDomain } from 'services/accounts/types';
import { ClaimPangolinKind, claim } from 'services/accounts/pangolin_service';
import { ResultKind } from 'services/base/types';
import { BusyStore } from 'ui/base/button';

export class AddPangolinMnemonicStore {
  readonly mnemonic: StringStore;

  @observable.ref
  mnemonicError: string | undefined;

  @observable.ref
  busy: BusyStore;

  constructor() {
    this.mnemonic = new StringStore('');
    this.busy = new BusyStore();
  }

  @action.bound
  async handleSubmit(domain: IAccountsDomain) {
    const result = await claim({
      domain,
      kind: ClaimPangolinKind.MNEMONIC,
      registrationNonceMnemonic: this.mnemonic.value,
    });
    return runInAction(() => {
      if (result.kind === ResultKind.USER_ERROR) {
        this.mnemonicError = result.registrationNonceMnemonicError;
      }
      return result;
    });
  }
}
